import * as Constants from '../../../constants/Constants';
import getBookingUrl from './getBookingUrl';
import getDoctorLocationId from './getDoctorLocationId';
import getTimeslotId from './getTimeslotId';
import moment from 'moment';
import parseConstraint from './parseConstraint';
import removeTimeZone from './removeTimeZone';
import '../../../utils/moment-extensions';

/**
 * @param {object} doctorLocation
 * @param {Array<moment>} dates
 * @param {object} state
 */
export function parseApiV2DoctorLocation(doctorLocation, dates, state) {
    const result = {};
    const times = {};
    const doctorLocationId = getDoctorLocationId(doctorLocation);

    initializeDates(dates, times);

    parseTimeslots(doctorLocation, state, times);

    setNextAppointment(doctorLocation, dates, times);

    result[doctorLocationId] = times;

    return result;
}

export function parseApiV2EmptyDoctorLocation(doctorLocationId, dates) {
    const result = {};
    const times = {};

    initializeDates(dates, times);

    result[doctorLocationId] = times;

    return result;
}

export function parseApiV2ShowGovernmentInsuranceNotice(doctorLocationId, dates) {
    const result = {};
    const times = {};

    initializeDates(dates, times);

    setShowGovernmentInsuranceNotice(dates, times);

    result[doctorLocationId] = times;

    return result;
}

function initializeDates(dates, times) {
    dates.forEach(date => {
        const time = moment(date);
        const formattedDate = time.format(Constants.DATE_FORMAT);

        times[formattedDate] = {
            date: time,
            appointments: [],
        };
    });
}

function parseTimeslots(doctorLocation, state, times) {
    doctorLocation.timeslots.forEach(timeslot => {
        const date = removeTimeZone(timeslot.start_time);
        const ticks = date.ticks();
        const formattedDate = date.format(Constants.DATE_FORMAT);

        times[formattedDate].appointments.push({
            date,
            doctorLocationUtcOffset: timeslot.utc_offset_seconds,
            id: getTimeslotId(ticks, doctorLocation),
            url: getBookingUrl(ticks, doctorLocation, state),
            constraint: parseConstraint(timeslot.constraint),
        });
    });
}

function setNextAppointment(doctorLocation, dates, times) {
    const nextAppointment = doctorLocation.next_timeslot || {};
    const nextAppointmentDate = nextAppointment.start_time ? moment(nextAppointment.start_time) : null;

    dates.forEach(date => {
        const time = moment(date);
        const formattedDate = time.format(Constants.DATE_FORMAT);

        if (nextAppointmentDate && time.dayDiff(nextAppointmentDate) <= 0) {
            times[formattedDate].nextAppointment = nextAppointmentDate;
        }
    });
}

function setShowGovernmentInsuranceNotice(dates, times) {
    dates.forEach(date => {
        const time = moment(date);
        const formattedDate = time.format(Constants.DATE_FORMAT);
        times[formattedDate].showGovernmentInsuranceNotice = true;
    });
}
